import { useTranslation } from 'react-i18next';
import { EngagementDetail, EngagementPostEditV2, EngagementPostMissingMetrics } from '@anytag/graphql';
import { Drawer, Form, RenderDataWithFallback } from '@anytag/shared-atoms';
import { FormAction } from '@anytag/shared-types';
import { EngagementPostSchema } from './schema';
import { Template } from './Template';
import { EngagementPostFormValues } from './types';
import { getEngagementPostFormValues } from './utils';

export interface EngagementPostFormProps extends Pick<FormAction<EngagementPostFormValues>, 'onSubmit'> {
  loading?: boolean;
  onClose: () => void;
  engagement: EngagementDetail;
  data?: Partial<EngagementPostEditV2> | null;
  postMissingMetricsData?: EngagementPostMissingMetrics | null;
}

export const EngagementPostForm = ({
  data,
  loading,
  onSubmit,
  onClose,
  engagement,
  postMissingMetricsData
}: EngagementPostFormProps) => {
  const { t } = useTranslation();

  const initialValues = getEngagementPostFormValues(data, postMissingMetricsData);

  return (
    <Drawer.Root
      className="w-129"
      onClose={onClose}
      title={t(engagement.isTtcmCampaign ? 'Video Detail' : 'Post Detail')}
      open
    >
      <RenderDataWithFallback loading={loading}>
        <Form.Provider onSubmit={onSubmit} values={initialValues} zodSchema={EngagementPostSchema}>
          <Template
            onClose={onClose}
            engagement={engagement}
            initialValues={initialValues}
            hasPostMissingMetricsData={!!postMissingMetricsData}
          />
        </Form.Provider>
      </RenderDataWithFallback>
    </Drawer.Root>
  );
};

export * from './types';
